import React from "react";
import { Button, Col, Row, Image } from "react-bootstrap";
import DtHeaderStyle from "./css/DtHeader.module.css";
import Logo from "../../../images/communityoflovelogo.png";
import facebook from "../../../images/mobile-header/facebook.png";
import Instagram from "../../../images/mobile-header/instagram.png";
import LinkedIn from "../../../images/mobile-header/linkedin.png";

const DesktopHeader = () => {
  const btnDesktop = DtHeaderStyle.btnDesktop;
  const LogoStyleDesktop = DtHeaderStyle.LogoStyleDesktop;
  const logoDesktopWrapper = DtHeaderStyle.logoDesktopWrapper;
  const socialIconStyle = DtHeaderStyle.socialIconStyle;
  const socialWrapperHeader = DtHeaderStyle.socialWrapperHeader;
  const titleDesktop = DtHeaderStyle.titleDesktop;
  const titleH2Desktop = DtHeaderStyle.titleH2Desktop;
  const colHeaderWrapper = DtHeaderStyle.colHeaderWrapper;
  const outreach = DtHeaderStyle.outreach;
  const comingSoon = DtHeaderStyle.comingSoon;
  const onlineCourses = DtHeaderStyle.onlineCourses;
  const donateTop = DtHeaderStyle.donateTop;
  const prayerTop = DtHeaderStyle.prayerTop;
  const instagramLink =
    "https://www.instagram.com/communityoflove2022/?utm_source=ig_web_button_share_sheet&igshid=OGQ5ZDc2ODk2ZA==";
  const LinkedInLink = "https://www.linkedin.com/in/sharon-chatman-4a2233287/";
  const facebookLink = "https://www.facebook.com/profile.php?id=61553859627050";

  return (
    <>
      <Row id="header">
        <Col className={colHeaderWrapper}>
          <div className={logoDesktopWrapper}>
            <a href="communityoflove2022.com">
              <Image src={Logo} className={LogoStyleDesktop} />
            </a>
          </div>
          <div>
            <h1 className={titleDesktop}>Community Of Love</h1>
            <h2 className={titleH2Desktop}>ALL FOR THE GLORY OF GOD</h2>
            <div className={socialWrapperHeader}>
              <a href={facebookLink}>
                <Image src={facebook} className={socialIconStyle} />
              </a>
              <a href={instagramLink}>
                <Image src={Instagram} className={socialIconStyle} />
              </a>
              <a href={LinkedInLink}>
                <Image src={LinkedIn} className={socialIconStyle} />
              </a>
            </div>
          </div>
        </Col>
      </Row>
      <Row style={{ marginBottom: ".8rem" }}>
        <Col style={{ paddingRight: "0" }} xs={6} md={4}>
          <div className={outreach}>
            <Button href="/cafe" className={btnDesktop}>
              GOD'S GOSPEL CAFE
            </Button>
          </div>
        </Col>
        <Col>
          <div className={comingSoon}>
            <Button href="/services" className={btnDesktop}>
              FAMILY SERVICES
            </Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col style={{ paddingRight: "0" }} xs={6} md={4}>
          <div className={onlineCourses}>
            <Button href="/#courses" className={btnDesktop}>
              FOREIGN LANGUAGE COURSES
            </Button>
          </div>
        </Col>
        <Col style={{ paddingRight: "0" }}>
          <div className={donateTop}>
            <Button href="/#quick-links" className={btnDesktop}>
              GIVE/SPONSOR
            </Button>
          </div>
        </Col>
        <Col>
          <div className={prayerTop}>
            <Button href="/prayer" className={btnDesktop}>
              REQUEST PRAYER
            </Button>
          </div>
        </Col>
      </Row>
    </>
  );
};
export default DesktopHeader;
